import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';

import StatesDescriptionUnit from './StatesDescriptionUnit.jsx';

import './StatesDescription.scss';

const StatesDescription = () => {
    return (
        <div className="states-description">
            <StatesDescriptionUnit
                title={LocaleService.t('TRADE_IN.CONDITION.TITLE.FAIR')}
                description={LocaleService.t('TRADE_IN.CONDITION.CONTENT.FAIR')}
            />
            <StatesDescriptionUnit
                title={LocaleService.t('TRADE_IN.CONDITION.TITLE.GOOD')}
                description={LocaleService.t('TRADE_IN.CONDITION.CONTENT.GOOD')}
            />
            <StatesDescriptionUnit
                title={LocaleService.t('TRADE_IN.CONDITION.TITLE.VERYGOOD')}
                description={LocaleService.t('TRADE_IN.CONDITION.CONTENT.VERYGOOD')}
            />
            <StatesDescriptionUnit
                title={LocaleService.t('TRADE_IN.CONDITION.TITLE.EXCELLENT')}
                description={LocaleService.t('TRADE_IN.CONDITION.CONTENT.EXCELLENT')}
            />
        </div>
    );
};

export default StatesDescription;



// WEBPACK FOOTER //
// ./src/components/EstimateTradeIn/components/StatesDescription/StatesDescription.jsx